var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8787 1.70729C12.0503 0.535721 13.9497 0.535719 15.1213 1.70729L17.2929 3.87887C18.4645 5.05044 18.4645 6.94993 17.2929 8.12151L8.41421 17.0002H18C18.5523 17.0002 19 17.4479 19 18.0002C19 18.5525 18.5523 19.0002 18 19.0002H1C0.447715 19.0002 0 18.5525 0 18.0002V13.0002C0 12.735 0.105357 12.4806 0.292893 12.2931L10.8787 1.70729ZM5.58579 17.0002L13.5858 9.00019L10 5.4144L2 13.4144V17.0002H5.58579ZM11.4142 4.00019L15 7.58597L15.8787 6.70729C16.2692 6.31677 16.2692 5.6836 15.8787 5.29308L13.7071 3.12151C13.3166 2.73098 12.6834 2.73098 12.2929 3.12151L11.4142 4.00019Z",
    fill: "#2A348C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.64502a81.svg";
export { ForwardRef as ReactComponent };